import React from 'react';

import { widgetMessages } from '../../../../../translates/widgetMessages';
import { useIntlReexport } from '../../../../hooks/useIntlReexport';
import { useSwitch } from '../../../../hooks/useSwitch';
import { Title } from '../../../components/common/Widget/Title';
import { TitleCaption } from '../../../components/common/Widget/TitleCaption';
import { StudentWidgetWrapper } from '../../../components/Widgets/StudentWidgetWrapper';
import { ExistingStudentWidgetProps } from '../Widget';
import { LocatingHiddenAreaWidget } from './LocatingHiddenAreaWidget';
import { HiddenAreaWidget as HiddenAreaWidgetModel } from '@ael/core-api';
import { StudentButton } from '@ael/shared-components-library';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './HiddenAreaWidget.scss';

export const HiddenAreaWidget: React.FC<ExistingStudentWidgetProps> = ({ widget }) => {
  const { isOn: isOpened, turnOn: openPano, turnOff: closePano } = useSwitch(false);
  const { isOn: isCompleted, turnOn: setCompleted } = useSwitch(false);

  const hiddenAreaWidget = widget as HiddenAreaWidgetModel;
  const { formatMessage } = useIntlReexport();
  const value = hiddenAreaWidget.value;

  const closeAndMarkCompletion = (success: boolean) => {
    closePano();
    if (success) {
      setCompleted();
    }
  };

  return (
    <>
      <StudentWidgetWrapper>
        <TitleCaption>{formatMessage(widgetMessages.hiddenAreaWidgetLocateOnScene)}</TitleCaption>
        <Title>{value.data.questionText}</Title>
        <div className="student-hidden-area-widget__button-wrapper">
          <StudentButton onClick={openPano}>{formatMessage(widgetMessages.hiddenAreaWidgetLocateButton)}</StudentButton>
          {isCompleted && (
            <div className="student-hidden-area-widget__success-text">
              <FontAwesomeIcon icon={solid('check')} /> {formatMessage(widgetMessages.hiddenAreaWidgetSuccessMessage)}
            </div>
          )}
        </div>
      </StudentWidgetWrapper>
      {isOpened && <LocatingHiddenAreaWidget widget={hiddenAreaWidget} onDone={closeAndMarkCompletion} />}
    </>
  );
};
